import { render, staticRenderFns } from "./BusinessContact.vue?vue&type=template&id=346c794e&"
import script from "./BusinessContact.vue?vue&type=script&lang=js&"
export * from "./BusinessContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInfoCard: require('/opt/buildhome/repo/components/base/InfoCard.vue').default,BaseLinks: require('/opt/buildhome/repo/components/base/Links.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/@nuxtjs/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VListItemSubtitle,VListItemTitle,VThemeProvider})
